module.exports = __webpack_public_path__ + "img/plurk.cfdec2b.svg";